import { Button, Modal, Upload } from '@socialive/ui';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearMediaUploads, selectAllMediaUploadsCompleted, selectMediaUploadAssetList } from '~/store';
import UploadForm from './UploadForm';

const RecordingUploadModal = ({ modal }) => {
  const dispatch = useDispatch();
  const uploadList = useSelector(selectMediaUploadAssetList);
  const areUploadsCompleted = useSelector(selectAllMediaUploadsCompleted);

  const closeAndClearUploads = useCallback(async () => {
    modal.close();
    await dispatch(clearMediaUploads({ trigger: 'RecordingUploadModal@closeAndClearUploads' }));
  }, [modal, dispatch]);

  return (
    <Modal
      title="Upload Recordings"
      visible
      onCancel={modal.close}
      width={600}
      onCloseButtonClick={modal.close}
      footer={
        areUploadsCompleted && (
          <Button context="primary" onClick={closeAndClearUploads} className="ml-auto">
            OK
          </Button>
        )
      }
    >
      {uploadList.length === 0 && <UploadForm />}
      {uploadList.length > 0 && (
        <p className="mb-4">
          Once your files are uploaded, you are free to leave Socialive while the videos are processing. Note that
          processing can take several minutes.
        </p>
      )}
      <div className="pr-5">
        {uploadList.map((upload) => (
          <Upload
            key={upload.id}
            className="mb-4"
            time={upload.uploadStartedAt}
            title={upload.fileName}
            progress={upload.progress}
            uploading={upload.isUploading}
            processing={upload.isProcessing}
            onError={upload.failed}
            hideContactSupportLink
          />
        ))}
      </div>
    </Modal>
  );
};

RecordingUploadModal.propTypes = {
  modal: PropTypes.shape({
    visible: PropTypes.bool,
    open: PropTypes.func,
    update: PropTypes.func,
    close: PropTypes.func,
  }).isRequired,
};

export default RecordingUploadModal;
